var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 7,
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.057 3.566 7.974.649l1.414 1.414-4.243 4.243-.088-.089-.084.085L.73 2.06 2.141.65l2.916 2.916Z",
  fill: "#2D2D2D",
  fillRule: "evenodd"
})));
export default SvgChevronDown;